var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('b-img',{attrs:{"fluid":"","src":require('../assets/aphasiatherapyresourceslogo.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }